import React from 'react';
import { ShieldCheck, Lock, CreditCard, Zap, FileText, MapPin } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-107">
      {/* Background glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/10 rounded-full blur-[120px] pointer-events-none" data-id="element-108"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-109">
        <div className="flex flex-col items-center" data-id="element-110">
          {/* Text Content */}
          <div className="flex-1 text-center max-w-3xl" data-id="element-111">
            <FadeIn data-id="element-112">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-surface border border-gold/30 text-gold text-sm font-semibold mb-6" data-id="element-113">
                <span className="relative flex h-2 w-2" data-id="element-114">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gold opacity-75" data-id="element-115"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-gold" data-id="element-116"></span>
                </span>
                SISTEMA N°1 PARA PADRES EN ARGENTINA
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-117">
              <h1 className="text-5xl md:text-7xl font-bold leading-tight mb-6" data-id="element-118">
                <span className="block text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400" data-id="element-119">
                  ADULTO DE
                </span>
                <span className="block text-gold drop-shadow-[0_0_15px_rgba(212,168,67,0.3)]" data-id="element-120">
                  RESCATE
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.15} data-id="element-121">
              <div className="mb-8" data-id="element-122">
                <img src="https://cdn.magicpatterns.com/uploads/45gAX5xrH7vkndVPg7MKsi/Diseno_sin_titulo_(2).png" alt="Adulto de Rescate — Kit Anti-Crisis para padres de adolescentes" className="mx-auto block max-w-xs md:max-w-md drop-shadow-2xl" data-id="element-123" />
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-124">
              <p className="text-xl md:text-2xl text-gray-300 font-medium mb-4" data-id="element-125">
                Todo lo que necesitás para acompañar a tu adolescente. Sin
                buscar. Sin improvisar. Sin perder más noches sin dormir.
              </p>
              <p className="text-lg text-gray-400 mb-8 max-w-2xl mx-auto" data-id="element-126">
                Herramientas tácticas para calmar ansiedad, frenar explosiones y
                reconectar con tu hijo.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-127">
              <div className="flex flex-wrap justify-center gap-4 mb-10" data-id="element-128">
                <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" data-id="element-129">
                  <span className="text-2xl" data-id="element-130">🩹</span>
                  <span className="font-medium text-sm" data-id="element-131">100% Práctico</span>
                </div>
                <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" data-id="element-132">
                  <Zap className="w-5 h-5 text-yellow" data-id="element-133" />
                  <span className="font-medium text-sm" data-id="element-134">Acceso Inmediato</span>
                </div>
                <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" data-id="element-135">
                  <span className="text-2xl" data-id="element-136">👨‍👩‍👧</span>
                  <span className="font-medium text-sm" data-id="element-137">13 a 18 años</span>
                </div>
                <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" data-id="element-138">
                  <span className="text-2xl" data-id="element-139">🛡️</span>
                  <span className="font-medium text-sm" data-id="element-140">Todas las crisis</span>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-141">
              <button onClick={() => {
              const target = document.getElementById('elegir-plan');
              if (target) {
                const start = window.scrollY;
                const end = target.getBoundingClientRect().top + window.scrollY - 20;
                const distance = end - start;
                const duration = 1000;
                let startTime: number | null = null;
                const easeOutQuart = (t: number) => 1 - Math.pow(1 - t, 4);
                const step = (timestamp: number) => {
                  if (!startTime) startTime = timestamp;
                  const elapsed = timestamp - startTime;
                  const progress = Math.min(elapsed / duration, 1);
                  window.scrollTo(0, start + distance * easeOutQuart(progress));
                  if (progress < 1) requestAnimationFrame(step);
                };
                requestAnimationFrame(step);
              }
            }} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-5 text-lg font-bold text-background bg-gold rounded-xl hover:bg-gold/90 transition-all animate-pulse-glow uppercase tracking-wider cursor-pointer" data-id="element-142">
                🛡️ → Quiero mi Kit Adulto de Rescate Ahora
              </button>

              <div className="flex flex-wrap justify-center items-center gap-6 mt-6 text-sm text-gray-400" data-id="element-143">
                <div className="flex items-center gap-2" data-id="element-144">
                  <ShieldCheck className="w-4 h-4 text-gold" data-id="element-145" />
                  <span data-id="element-146">Garantía 7 días</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-147">
                  <Lock className="w-4 h-4 text-gold" data-id="element-148" />
                  <span data-id="element-149">Pago seguro</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-150">
                  <CreditCard className="w-4 h-4 text-gold" data-id="element-151" />
                  <span data-id="element-152">Mercado Pago</span>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}